import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { addPropertyToBusiness, BusinessAction, setSetting } from "actions";

import BusinessPICSelector from "components/BusinessPICSelector";

import {
  getKeywordLookups,
  getProperties,
  getSettings,
  selectActivePropertyEnrichedBusinessByBusinessIdLookup,
} from "selectors";

const mapDispatchToProps = {
  addBusiness: BusinessAction.create,
  addPropertyToBusiness,
  setSetting,
};

const mapStateToProps = (state, props) => ({
  businesses: selectActivePropertyEnrichedBusinessByBusinessIdLookup(state),
  properties: getProperties(state),
  keywordLookups: getKeywordLookups(state, props),
  offlineLookup: state.offlineTemp,
  settings: getSettings(state),
});

const StateAwareBusinessPICSelector = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(BusinessPICSelector);

StateAwareBusinessPICSelector.propTypes = {
  agencyId: PropTypes.number,
  allowBusinessOnly: PropTypes.bool,
  allowPropertyOnly: PropTypes.bool,
  businessFieldName: PropTypes.string,
  businessRoles: PropTypes.array,
  formikProps: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  onAfterSelect: PropTypes.func,
  openInstance: PropTypes.string,
  propertyFieldName: PropTypes.string,
  searchPrefill: PropTypes.string,
  saleyardName: PropTypes.string,
  focusControl: PropTypes.obj,
  focusNextInput: PropTypes.func,
};

export default StateAwareBusinessPICSelector;
